module.exports = __webpack_public_path__ + "img/45.1ecb30b2.jpg";